import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react'
import { ThemeProvider } from 'next-themes'
import './styles/index.css'
import './styles/globals.css'
import App from './App.tsx'
import { Analytics } from './analytics/Analytics'
import { authConfig, authScopes } from './auth/config'
import { runCrossOriginVerification } from './auth/embeddedLogin'

const { domain, clientId, audience } = authConfig

if (!runCrossOriginVerification()) createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      cacheLocation={authConfig.cacheLocation}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: audience,
        scope: authScopes
      }}
    >
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
        <Analytics />
        <App />
      </ThemeProvider>
    </Auth0Provider>
  </StrictMode>,
)
